/* The one API client of the Brightivity web app. Every call goes to API_BASE (brightivity.dev). */
import { API_BASE } from '../config.js';

const KEY = 'bv.session';
let listeners = [];

export function getSession() {
  try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; }
}
export function setSession(s) {
  try { s ? localStorage.setItem(KEY, JSON.stringify(s)) : localStorage.removeItem(KEY); } catch { /* storage blocked */ }
  listeners.forEach((f) => f(s));
}
export function onSession(f) {
  listeners.push(f);
  return () => { listeners = listeners.filter((x) => x !== f); };
}

/** api('/auth/me') → { ok, status, data, error } — never throws for HTTP errors. */
export async function api(path, { method = 'GET', body, auth = true, signal } = {}) {
  const s = getSession();
  const headers = {};
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (auth && s && s.token) headers.Authorization = `Bearer ${s.token}`;
  let res;
  try {
    res = await fetch(`${API_BASE}${path}`, { method, headers, body: body === undefined ? undefined : JSON.stringify(body), signal });
  } catch (e) {
    return { ok: false, status: 0, error: 'Cannot reach Brightivity. Check your internet connection.', detail: String(e && e.message) };
  }
  let data = null;
  try { data = await res.json(); } catch { /* empty body */ }
  if (res.status === 401 && auth && s) setSession(null);
  if (!res.ok) return { ok: false, status: res.status, data, error: (data && (data.error || data.message)) || `Something went wrong (${res.status})` };
  return { ok: true, status: res.status, data };
}
